"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tooltip_styles_1 = __importDefault(require("./Tooltip.styles"));
var Tooltip = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement(Tooltip_styles_1.default, null,
        react_1.default.createElement("span", null, "i"),
        react_1.default.createElement("p", null, text)));
};
exports.default = Tooltip;
